import { VCycleElementContainerContent } from './VCycleElementContainerContent';
import {
    defaultVCycleElementContainerResource,
    useVCycleElementContainerActions,
    VCycleElementContainerMutationResourceSchema,
    VCycleElementContainerResource,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementContainerResource';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { creationDialogOnSuccess } from '../../../util/utilFunctions';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import React from 'react';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const VCycleElementContainerCreationDialog= ({ onClose, parentId, projectId, projectVersionId, autoGeneratedProps, onCreated }: {
    onClose: () => void;
    parentId: string;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    autoGeneratedProps?: VCycleElementContainerResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const vcycleElementContainerActions = useVCycleElementContainerActions()
    const addVCycleElementContainer = vcycleElementContainerActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementContainerMutationResourceSchema,
        defaultValues: {
            ...defaultVCycleElementContainerResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addVCycleElementContainer.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create V-Cycle Element Container'}
            resourceType={ResourceType.V_CYCLE_ELEMENT_CONTAINER}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <VCycleElementContainerContent projectId={projectId} projectVersionId={projectVersionId} form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};